import { Component, OnInit } from '@angular/core';
import { Unit } from '../unit';
import { UnitService } from '../unit.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-unit',
  templateUrl: './unit.component.html',
  styleUrls: ['./unit.component.css'],
  providers: [UnitService],
  host: {'window:beforeunload':'doSomething'},
  preserveWhitespaces: false
})
export class UnitComponent implements OnInit {

units: Unit[];
loading: boolean = false;

  constructor(private unitService: UnitService, private router: Router) { }

  ngOnInit() {
        this.loading= true;
        this.unitService.getUnit().subscribe(response=> {
                                                       console.log(response);
                                                         this.units=response['data'];
                                                         this.loading= false;
                                                       });
    }
    
  doSomething(){
    alert('Hello World');
  } 

 

  create():void {
   		this.router.navigate(['dashboard/unit-crud']);
  }  

  edit(id: any){
    	 this.router.navigate(['dashboard/unit-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/units/unit/unit.component.ts